import { EntityApi, LoopBackAuth } from '../../../sdk';
import { FormBuilder } from '@angular/forms';
import { AbstractWidgetComponent, getFieldFromArray, isNotEmpty } from '../../../utils/util';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
//import 'ag-grid-enterprise/main';
import { DataelementApi } from '../../../sdk/services/custom';
import * as _ from 'lodash';
import { PlatformApp } from '../../../services/app.service';
@Component({
    selector: 'barchart-widget',
    templateUrl: './barchart.component.html',
    styleUrls: ['./barchart.component.scss']

})

export class BarchartWidgetComponent extends AbstractWidgetComponent implements OnInit, OnDestroy {
    id = 'barchartdiv' + Math.floor((Math.random() * 1000000000000) + 1);
    @Input() title = '';
    ddd = false;
    @Input() widget: any;
    _dataelementid = '';
    _comparefields = [];
    _basefield = '';
    notifyOptions = PlatformApp.getNotificationOptions();
    constructor(_dataelementApi: DataelementApi, fb: FormBuilder,
        _loopBackAuth: LoopBackAuth, _entityApi: EntityApi) {
        super(_dataelementApi, fb, _loopBackAuth, _entityApi);

    }

    ngOnInit(): void {
        if (this.widget) {
            this.ddd = Boolean(this.widget.ddd);
            this.autorefresh = Boolean(this.widget.autorefresh);
            this._comparefields = isNotEmpty(this.widget.comparefields) ? this.widget.comparefields : [this.widget.comparefield];
            this._basefield = this.widget.basefield;
            this._dataelementid = this.widget.dataelement;
            this.title = this.widget.title;
            if (isNotEmpty(this.widget.filterfields)) {
                this.filter_fields = _.cloneDeep(this.widget.filterfields);
            }
        }
        this.options = this.createChartConfig();
        this.setChartConfig();
    }

    createChartConfig(dataelement?) {
        let options = {
            'theme': 'light',
            'type': 'serial',
            'dataProvider': [],
            'valueAxes': [],
            'graphs': [],
            'depth3D': 0,
            'angle': 10,
            'categoryField': this._basefield,
            'legend': {
                'enabled': true,
                'useGraphSettings': true
            },
            'categoryAxis': {
                'gridPosition': 'start',
                'fillAlpha': 0.05,
                'autoRotateAngle': 20,
                'autoRotateCount': 4
            }
        };
        if (dataelement) {
            options.dataProvider = dataelement.data;
            let bfield = getFieldFromArray(dataelement.fields, this._basefield);
            if (bfield) { options.categoryField = bfield.name; }
            this._comparefields.forEach(cf => {
                let cfield = getFieldFromArray(dataelement.fields, cf);
                if (cfield) {
                    let ygraph = {
                        'balloonText': '[[category]]:[[value]]',
                        'fillAlphas': 0.9,
                        'lineAlpha': 0.2,
                        'title': cfield.label,
                        'type': 'column',
                        'valueField': cfield.name
                    };
                    if (cfield.unit) {
                        ygraph.balloonText += ' ' + cfield.unit;
                    }
                    options.graphs.push(ygraph);
                    options.valueAxes.push({ 'title': cfield.label, position: 'left' });
                }
            });

        }
        if (this.ddd) {
            options.depth3D = 30;
            options.angle = 20;
        }
        //console.log('options:-', JSON.stringify(options));
        return options;
    }

    ngOnDestroy() {
        clearInterval(this._timer);
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/barchart/barchart.component.ts